export * from "./InventoryTable";
